// frontend/src/components/capacitor/CapacitorProcessing.tsx
import './Capacitor.css'

interface Props {
  progress: number
  message: string
}

export function CapacitorProcessing({ progress, message }: Props) {
  return (
    <div className="cap-processing">
      <div className="cap-processing-emoji">⏳</div>
      <h2 className="cap-processing-title">Chat wird verarbeitet…</h2>
      <p className="cap-processing-status">{message}</p>
      <div className="cap-progress-bar">
        <div className="cap-progress-fill" style={{ width: `${progress}%` }} />
      </div>
    </div>
  )
}
